import { Controller } from '@hotwired/stimulus'

// Simple controller to load a single stat value from an API endpoint
export default class extends Controller {
  static targets = ['value']

  static values = {
    url: String,
    key: String
  }

  connect() {
    this.loadStat()
  }

  async loadStat() {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      const value = data[this.keyValue]

      if (this.hasValueTarget) {
        this.valueTarget.textContent = this.formatNumber(value)
      }
    } catch (error) {
      console.error('Failed to load stat:', error)
      if (this.hasValueTarget) {
        this.valueTarget.textContent = '-'
      }
    }
  }

  formatNumber(num) {
    if (num === null || num === undefined) return '-'
    return new Intl.NumberFormat().format(num)
  }
}
